import { useAuthorization } from "~/contexts/authorizationProvider";
import { useOrgRouter } from "~/utils/paths";
import { routes } from "~/utils/routes";

const OrgSlugIndex = () => {
  const router = useOrgRouter();
  const { roleHomepage } = useAuthorization();

  // A role may pin its own landing page (`Role.defaultHomepage`); an admin's explicit choice wins.
  if (!!roleHomepage) {
    return void router.push(roleHomepage);
  }

  return void router.push(routes.products);
};

export default OrgSlugIndex;
